export default __webpack_public_path__ + "static/media/FrozenABC_03.45a26736.png";